import { useContext } from "react";
import { AuthContext } from "../../context/authentication/Auth.context";

const Home = () => {
  const { currentUser } = useContext(AuthContext);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        textTransform: "uppercase",
        fontSize: 16,
        gap: 5,
      }}
    >
      <span style={{ fontWeight: "bold" }}>welcome, </span>{" "}
      {currentUser.username}
    </div>
  );
};

export default Home;
